import React from 'react'
import {
  Box,
  Container,
  Heading,
  Text,
  VStack,
  Stack,
} from '@chakra-ui/react'
import LandingProductShot from './LandingProductShot.jsx'
import MicrositeTemplateGallery from './MicrositeTemplateGallery.jsx'

const PILLARS = [
  {
    id: 'gestion',
    title: 'Gestión',
    description:
      'Plantilla de músicos, formaciones, ensayos, actuaciones, documentos, objetivos y permisos. El día a día de la agrupación, en un solo sitio.',
    shot: 'gestion',
  },
  {
    id: 'archivo',
    title: 'Archivo',
    description:
      'Obras, carpetas y voces. Sube tus obras, organízalas en carpetas y compártelas con tus músicos.',
    shot: 'archivo',
  },
  {
    id: 'web',
    title: 'Tu Web',
    description:
      'Una frontpage con hasta 9 aspectos diferentes para cubrir todas tus necesidades a la hora de darte a conocer.',
    shot: 'web',
  },
]

const ValueProposition = () => (
  <Box id="producto" data-landing="producto" bg="white" py={{ base: 16, md: 24 }}>
    <Container maxW="7xl">
      <VStack gap={{ base: 12, md: 16 }}>
        <VStack gap={4} textAlign="center">
          <Heading
            as="h2"
            fontSize={{ base: '3xl', md: '4xl', lg: '5xl' }}
            fontWeight="800"
            color="gray.800"
          >
            Hecho para tu banda
          </Heading>
          <Text fontSize={{ base: 'lg', md: 'xl' }} color="gray.600" maxW="2xl">
            Gestiona y contacta. Controla todos los aspectos de tu banda en profundidad.
          </Text>
        </VStack>

        <VStack gap={{ base: 12, md: 16 }} w="full">
          {PILLARS.map((pillar, index) => (
            <Stack
              key={pillar.id}
              direction={{ base: 'column', lg: index % 2 === 1 ? 'row-reverse' : 'row' }}
              gap={{ base: 8, lg: 14 }}
              align="center"
              w="full"
            >
              <VStack flex={1} align={{ base: 'center', lg: 'flex-start' }} textAlign={{ base: 'center', lg: 'left' }} gap={4}>
                <Heading size="lg" color="gray.800">
                  {pillar.title}
                </Heading>
                <Text color="gray.600" fontSize="lg" lineHeight="tall">
                  {pillar.description}
                </Text>
              </VStack>
              <Box flex={1} w="full">
                <LandingProductShot variant={pillar.shot} />
              </Box>
            </Stack>
          ))}
        </VStack>

        <MicrositeTemplateGallery />
      </VStack>
    </Container>
  </Box>
)

export default ValueProposition
